<template>
  <div>
    <div class="p-1 rounded-lg border-2 border-gray-200">
      <div
        ref="contentRef"
        class="p-1 rich-content scroll-mt-4 w-full overflow-scroll"
        :class="{ 'rich-content--collapsed': !expanded && needsToggle }"
        :style="{ maxHeight: currentMaxHeight }"
        v-html="content"
      ></div>
      <button
        v-if="needsToggle"
        @click="toggleExpanded"
        class="toggle-btn mt-2"
      >
        {{ expanded ? "Show less" : "Show more" }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed, nextTick, onMounted, ref, watch } from "vue";

const props = defineProps({
  content: { type: String, required: true },
});

const contentRef = ref(null);
const expanded = ref(false);
const needsToggle = ref(false);
const fullHeight = ref(0);

const collapsedHeight = 200;

const currentMaxHeight = computed(() => {
  if (expanded.value) {
    return fullHeight.value ? `${fullHeight.value}px` : "none";
  }
  return needsToggle.value ? `${collapsedHeight}px` : "none";
});

function checkOverflow() {
  const el = contentRef.value;
  fullHeight.value = el.scrollHeight;
  needsToggle.value = el.scrollHeight > collapsedHeight + 5;
}

function toggleExpanded() {
  expanded.value = !expanded.value;

  if (!expanded.value) {
    contentRef.value?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
    });
  }
}

onMounted(() => {
  nextTick(checkOverflow);
});

watch(
  () => props.content,
  () => {
    nextTick(checkOverflow);
  },
);
</script>

<style scoped>
.rich-content {
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
}

.rich-content--collapsed {
  max-height: 200px;
  position: relative;
  mask-image: linear-gradient(to bottom, black 80%, transparent 100%);
  -webkit-mask-image: linear-gradient(to bottom, black 80%, transparent 100%);
}
</style>
